import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { ChevronRightTallIcon } from '@root/shared/ui-kit'

import type { ReactNode } from 'react'

type SwapInfoLineProps = {
  label: ReactNode
  value: ReactNode
  onChevron?: () => void
}

export const WalletSwapDetailsLine: React.FC<SwapInfoLineProps> = ({
  label,
  value,
  onChevron,
}) => {
  const haptics = useHapticFeedback()

  return (
    <Root>
      <Label>{label}</Label>
      <Line />
      <ValueContainer
        data-clickable={!!onChevron}
        onClick={() => {
          if (onChevron) {
            haptics.impactOccurred('light')
            onChevron()
          }
        }}
      >
        <Value>{value}</Value>
        {onChevron ? <ChevronRightTallIcon size={16} /> : undefined}
      </ValueContainer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  grid-gap: 8px;
`

const Label = styled.div`
  color: var(--text-7);
  font-size: var(--swap-details-label-font-size);
  font-weight: 400;
  line-height: var(--swap-details-row-line-height);
`

const Line = styled.div`
  height: calc(var(--swap-details-label-font-size) + 2px);
  border-bottom: 1px solid var(--backgroundA-4);
`

const Value = styled.div`
  font-size: var(--swap-details-value-font-size);
  font-weight: 400;
  line-height: var(--swap-details-row-line-height);
`

const ValueContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 2px;
  align-items: center;

  color: var(--text-11);
  transition: color 0.2s linear;

  &[data-clickable] {
    cursor: pointer;
    &:hover {
      color: var(--text-12);
    }
  }
`
